import { Grid, Tooltip, Typography } from '@material-ui/core';
import moment from 'moment-timezone';
import React from 'react';

import {
  DateGroup,
  DateGroupDays,
  DateGroupHours,
  DateGroupMonths,
  DateGroupWeeks,
  isDateGroupDaysEnabled,
  isDateGroupHoursEnabled,
} from '~/src/dash/api/console-api';

interface IProps {
  densityRange: DateGroup;
  handleDensityRangeChange: (densityRange: string) => void;
  classes: { [key: string]: string };
  calStartDate: moment.Moment;
  calEndDate: moment.Moment;
  hourAggRangeDisabled?: boolean;
}

export const DashboardDateToggles = (props: IProps) => {
  const {
    densityRange,
    handleDensityRangeChange,
    classes,
    calStartDate,
    calEndDate,
    hourAggRangeDisabled,
  } = props;
  return (
    <Grid container spacing={1} style={{ padding: 5 }}>
      {!hourAggRangeDisabled && (
        <Grid
          item
          lg={3}
          md={4}
          sm={6}
          xs={12}
          onClick={() => handleDensityRangeChange(DateGroupHours)}
        >
          <Typography
            className={
              densityRange === DateGroupHours
                ? classes.densityRangeSelected
                : classes.densityRangeNotSelected
            }
          >
            {isDateGroupHoursEnabled(calStartDate, calEndDate) ? (
              'Hour'
            ) : (
              <Tooltip title='Please select a timeframe less than 10 days in order to access hourly data'>
                <span>Hour</span>
              </Tooltip>
            )}
          </Typography>
        </Grid>
      )}
      <Grid
        item
        lg={3}
        md={4}
        sm={6}
        xs={12}
        onClick={() => handleDensityRangeChange(DateGroupDays)}
      >
        <Typography
          className={
            densityRange === DateGroupDays
              ? classes.densityRangeSelected
              : classes.densityRangeNotSelected
          }
        >
          {isDateGroupDaysEnabled(calStartDate, calEndDate) ? (
            'Day'
          ) : (
            <Tooltip title='Please select a timeframe less than 60 days in order to access daily data'>
              <span>Day</span>
            </Tooltip>
          )}
        </Typography>
      </Grid>
      <Grid
        item
        lg={3}
        md={4}
        sm={6}
        xs={12}
        onClick={() => handleDensityRangeChange(DateGroupWeeks)}
      >
        <Typography
          className={
            densityRange === DateGroupWeeks
              ? classes.densityRangeSelected
              : classes.densityRangeNotSelected
          }
        >
          Week
        </Typography>
      </Grid>
      <Grid
        item
        lg={3}
        md={4}
        sm={6}
        xs={12}
        onClick={() => handleDensityRangeChange(DateGroupMonths)}
      >
        <Typography
          className={
            densityRange === DateGroupMonths
              ? classes.densityRangeSelected
              : classes.densityRangeNotSelected
          }
        >
          Month
        </Typography>
      </Grid>
    </Grid>
  );
};
